import { render, staticRenderFns } from "./H5LoginPopup.vue?vue&type=template&id=65b387e6&scoped=true&"
import script from "./H5LoginPopup.vue?vue&type=script&lang=js&"
export * from "./H5LoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./H5LoginPopup.vue?vue&type=style&index=0&id=65b387e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b387e6",
  null
  
)

export default component.exports